// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"5eca54fa","453":"9ae6de6b","732":"1961a91a"}[chunkId] + ".chunk.js";
};